import { render } from "./BarcodeRowMulti.vue?vue&type=template&id=39a602f1"
import script from "./BarcodeRowMulti.vue?vue&type=script&lang=ts"
export * from "./BarcodeRowMulti.vue?vue&type=script&lang=ts"
script.render = render

export default script